// import uiConfig from 'src/lib/ui/config';

import { Locale, localeRuleset } from 'src/replicant/ruleset/locale';
import { retry } from '../utils';

let currentLocale: Locale = localeRuleset.fallbackLocale;

// Map of loadable locales
export const loadableLocales: Record<Locale, boolean> = {
  en: true,
  // ja: true,
};

// Map of cached locales
const cachedLocales: Partial<Record<Locale, object>> = {};

export function getUsableLocale(choice: string): Locale {
  return loadableLocales[choice]
    ? (choice as Locale)
    : localeRuleset.fallbackLocale;
}

export async function loadLocale(locale: string) {
  if (!cachedLocales[locale]) {
    const localePath = `./assets/i18n/${locale}.json`; // Path is determined in scripts/generate-font-data.ts

    const res = await retry(async () => {
      const res = await fetch(localePath);

      if (!res.ok) {
        const responseBody = await res.text();

        throw Error(
          `Fetching ${localePath} failed with ${res.status}: ${responseBody}`,
        );
      }

      return res;
    });

    cachedLocales[locale] = await res.json(); // eslint-disable-line require-atomic-updates
  }

  currentLocale = locale as Locale;
}

export function getStrings(): any {
  return cachedLocales[currentLocale];
}

export default function getString(
  key: string,
  substitutions?: { [key: string]: any },
  forceLocale?: Locale,
): string {
  const splitKeys = key.split('.');
  const lastKeyIndex = splitKeys.length - 1;

  let data = cachedLocales[forceLocale || currentLocale];

  for (let i = 0; i < lastKeyIndex; i++) {
    data = data[splitKeys[i]];

    if (data === undefined) break;
  }

  let result: string = data && data[splitKeys[lastKeyIndex]];

  if (result === undefined) {
    // return forceLocale ? key : getString(key, substitutions, fallbackLocale);
    return key;
  }

  if (substitutions) {
    for (const token in substitutions) {
      result = result.replace('{' + token + '}', substitutions[token]);
    }
  }

  return result;
}
